import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import IpadNavigation from 'Navigation/IpadNavigation'
import {TaxPaymentReportView} from 'Reports/views/TaxPaymentReport/TaxPaymentReportView/containers/Smartphones'

import getLeftComponent from 'Navigation/helpers/linkAccordance'

export class TaxPaymentReport extends Component {
  static propTypes = {
    t: PropTypes.func,
    previousLink: PropTypes.string
  }

  render () {
    const {t, previousLink} = this.props
    return (
      <IpadNavigation notBack {...this.props} title={t('navbar', 'title').s}>
        {getLeftComponent('report', previousLink)}
        <TaxPaymentReportView {...this.props} />
      </IpadNavigation>
    )
  }
}

function mapStateToProps (state) {
  return {
    t: state.i18n.get('app', 'views', 'Reports', 'TaxPayment', 'Report'),
    previousLink: state.appInfo.previousLink
  }
}

export default connect(mapStateToProps)(TaxPaymentReport)
